<template>
    <div class="animated fadeIn">
        <section class="section">
            <div class="padding-top-2x padding-bottom-2x">
                <div class="columns is-centered">
                    <div class="column intro-text content is-mobile">
                        <h3 class="is-size-3 small-container padding-bottom-1x uptin-text-center">
                            {{ $t('poc:poc.effordable-title') }}
                        </h3>
                    </div>
                </div>
                <div class="columns is-centered">
                    <div class="column content" style="flex: inherit">
                        <figure class="image img-700" v-if="!isMobile()">
                            <img alt="Affordable PTT" src="./assets/application.svg">
                        </figure>
                        <figure class="image featured-in-img-mobile mobile-screen" v-else>
                            <img alt="Affordable PTT" src="./assets/application.svg">
                        </figure>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container">
                        <p class="is-size- small-container uptin-text-center uptin-text-7">
                            {{ $t('poc:poc.effordable-description') }}
                        </p>
                    </div>
                </div>

                <div class="columns">
                    <div class="column intro-text content small-container padding-top-2x uptin-text-center">
                        <router-link :to="'tariff'" class="uptin-text-center uptin-text-7 text-dark" active-class="is-active is-active--advertiser">
                            {{ $t('poc:poc.effordable-more') }}
                            <i v-bind:class = "isPersian(currentLocale)?'fas fa-angle-left text-dark':'fas fa-angle-right text-dark'"></i>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss">
</style>

<script>
export default {
    components: {
    },
    name: 'affordable',
    data() {
        return {
            currentLocale: this.$i18n.i18next.language || window.localStorage.i18nextLng
        };
    },
    methods: {
        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        isPersian(locale) {
            return locale.toLowerCase() === 'fa' || locale.toLowerCase() === 'ar';
        }
    }
}
</script>
